import { intersectionObserve } from "./_intersection-observer";

window.addEventListener("load", function () {
	const nextDepartureElements = document.querySelectorAll(
		".next-departure-container"
	);
	observeNextDepartureElements(nextDepartureElements);
	console.log(nextDepartureElements);
});

export function observeNextDepartureElements(elements) {
	intersectionObserve(elements, 0, 0, (element, intersectionRatio) => {
		(function (el) {
			if (intersectionRatio > 0) {
				getNextDepartures(el);
			}
		})(element);
	});
}

function formatTime(time, lang) {
	if (lang == "nb-NO") {
		return time.toLocaleTimeString("no-NB", {
			hour: "2-digit",
			minute: "2-digit",
		});
	} else {
		return time.toLocaleTimeString("en-US", {
			timeStyle: "short",
		});
	}
}

function formatDate(date, lang) {
	if (lang == "nb-NO") {
		return date.toLocaleDateString("no-NB", {
			day: "numeric",
			month: "long",
		});
	} else {
		return date.toLocaleDateString("en-US", {
			day: "numeric",
			month: "long",
		});
	}
}

function getNextDepartures(element) {
	if (element.classList.contains("next-departure-loaded")) {
		return;
	}
	const departureTextField = element.querySelector(".next-departure");
	const departurePreTextField = element.querySelector(
		".next-departure-pre-text"
	);
	const loader = element.querySelector(".loader");
	const todayDateString = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
	const todayDateTime = new Date(); // Get today's date and time

	element.classList.add("next-departure-loaded");

	const productCode = element.getAttribute("data-iticket-productcode");
	jQuery.ajax({
		type: "POST",
		url: rodne_scripts.ajax_url,
		data: {
			action: "get_product_departures",
			product_code: productCode,
		},
		success: function (output) {
			let departures = output["departures"] || [];

			if (departures?.length > 0) {
				departures = departures.filter((departure) => {
					return departure.availableCapacity > 0;
				});
			}

			const todayDepartures = departures.filter((departure) => {
				return (
					new Date(departure["datetime"])
						.toISOString()
						.split("T")[0] == todayDateString
				);
			});

			const hasDeparturesToday = todayDepartures.length > 0;

			let nextAvailableTour = null;

			if (departures.length > 0) {
				const firstAvailableDate = new Date(departures[0]["datetime"])
					.toISOString()
					.split("T")[0];

				if (hasDeparturesToday) {
					departures = todayDepartures;
				} else {
					departures = departures.filter((departure) => {
						return (
							new Date(departure["datetime"])
								.toISOString()
								.split("T")[0] == firstAvailableDate
						);
					});
				}

				const lang = document.documentElement.lang;
				let text = "";

				if (hasDeparturesToday) {
					text = lang == "nb-NO" ? "I dag kl. " : "Today at ";
				} else {
					text =
						formatDate(new Date(firstAvailableDate), lang) +
						(lang === "nb-NO" ? " kl. " : " at ");
				}

				// Format all of the depature times
				const times = departures.map((departure) => {
					return formatTime(new Date(departure["datetime"]), lang);
				});

				// Join the n-1 times with a comma
				text += times
					.slice(0, Math.max(times.length - 1, 1))
					.join(", ");

				// Add the last departure time with a "and" separator
				if (times.length > 1) {
					text +=
						(lang == "nb-NO" ? " og " : " and ") +
						times[times.length - 1];
				}

				departureTextField.innerHTML = text;

				// If there are multiple departures, change the pre-text to plural
				if (departures.length > 1) {
					departurePreTextField.innerHTML =
						departurePreTextField.dataset.multipleDepaturesText +
						":";
				}
			} else {
				const noFutureDepartures = element.querySelector(
					".no-future-departures"
				);
				const departureTextField = element.querySelector(
					".next-departure-pre-text"
				);

				const nextDepartureTextField =
					element.querySelector(".next-departure");
				noFutureDepartures.classList.remove("hidden");
				departureTextField.classList.add("hidden");
				nextDepartureTextField.classList.add("hidden");
			}

			loader.classList.add("hidden");
		},
	});
}
